import * as React from 'react';
export const dropboxsignSvg = React.forwardRef(function dropboxsignSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7F5F2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm5 13.344 11 7.525v-9.3L5 4v9.344Z',
      fill: '#0061FE',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm27 4-11 7.57v9.3l11-7.526V4.001Z',
      fill: '#1E1919',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27 19.097 16 11.57v9.301l11 7.569v-9.344Z',
      fill: '#0061FE',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm5 28.44 11-7.568v-9.3L5 19.096v9.343Z',
      fill: '#1E1919',
    }),
  );
});
dropboxsignSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dropboxsign = {
  category: 'brand',
  colorable: false,
  name: 'dropboxsign',
  svg: dropboxsignSvg,
};
